import React from 'react'
export const Navigation = () => {

    return <div style={{position: 'fixed', top: '20px', right: '20px'}}><img style={{filter: 'invert(100%)', width: '200px'}} src='assets/images/mayu_logo.svg' /></div>
  
}